export default __webpack_public_path__ + "static/media/24.d5a19872.jpg";